// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-profile-edit .wm-profile-edit-form {
  display: block;
  padding: 16px;
}
wm-profile-edit .wm-profile-edit-avatar-container {
  display: flex;
  justify-content: center;
  padding: 24px 16px 20px;
}
wm-profile-edit .wm-profile-edit-avatar {
  position: relative;
  width: 104px;
  height: 104px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
}
wm-profile-edit .wm-profile-edit-avatar:focus-visible {
  outline: 2px solid var(--wm-color-primary, #4285f4);
  outline-offset: 3px;
}
wm-profile-edit .wm-profile-edit-avatar-circle {
  width: 100%;
  height: 100%;
}
wm-profile-edit .wm-profile-edit-avatar-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
wm-profile-edit .wm-profile-edit-avatar-initials {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--wm-color-primary, #4285f4);
  color: #fff;
  font-size: 2.1rem;
  font-weight: 600;
  border-radius: 50%;
}
wm-profile-edit .wm-profile-edit-avatar-scrim {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(15, 17, 23, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
wm-profile-edit .wm-profile-edit-avatar-spinner {
  width: 30px;
  height: 30px;
}
wm-profile-edit .wm-profile-edit-avatar-badge {
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--wm-color-primary, #4285f4);
  border: 3px solid var(--wm-color-white, #fff);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}
wm-profile-edit .wm-profile-edit-save-button {
  min-height: 44px;
  min-width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  background: var(--wm-color-primary, #4285f4);
  color: #fff;
  border-radius: 8px;
  font-size: var(--wm-font-md, 1rem);
  width: 100%;
  margin-top: 16px;
}
wm-profile-edit .wm-profile-edit-save-button[disabled] {
  opacity: 0.6;
}
wm-profile-edit ion-card.wm-profile-edit-fields-card {
  margin: 0 0 16px;
  box-shadow: none;
  background: var(--wm-color-greybackground, #f2f2f2);
  border: 1px solid var(--wm-color-grey, #d2d2d2);
  border-radius: 14px;
  padding: 4px 14px;
}
wm-profile-edit .wm-profile-edit-field-container {
  padding: 10px 0;
}
wm-profile-edit .wm-profile-edit-field-container ion-item {
  --background: transparent;
  --padding-start: 0;
  --inner-padding-end: 0;
}
wm-profile-edit .wm-profile-edit-field-divider {
  height: 1px;
  background: var(--wm-color-grey, #d2d2d2);
  margin: 0 -14px;
}
wm-profile-edit .wm-profile-edit-label {
  display: block;
  margin-bottom: 4px;
  font-size: var(--wm-font-sm, 0.85rem);
}
wm-profile-edit .wm-profile-edit-field-has-error {
  --border-color: var(--wm-color-danger, #eb445a);
  --highlight-color-focused: var(--wm-color-danger, #eb445a);
}
wm-profile-edit .wm-profile-edit-field-error {
  display: block;
  margin-top: 4px;
  color: var(--wm-color-danger, #eb445a);
  font-size: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/profile/profile-edit/profile-edit.component.scss"],"names":[],"mappings":"AACE;EACE,cAAA;EACA,aAAA;AAAJ;AAGE;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AADJ;AAQE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AANJ;AAQI;EACE,mDAAA;EACA,mBAAA;AANN;AAUE;EACE,WAAA;EACA,YAAA;AARJ;AAUI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AARN;AAYE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;AAeE;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAbJ;AAgBE;EACE,WAAA;EACA,YAAA;AAdJ;AAmBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AAjBJ;AAsBE;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,4CAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;AApBJ;AAsBI;EACE,YAAA;AApBN;AA8BE;EACE,gBAAA;EACA,gBAAA;EACA,mDAAA;EACA,+CAAA;EACA,mBAAA;EACA,iBAAA;AA5BJ;AA+BE;EACE,eAAA;AA7BJ;AA+BI;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;AA7BN;AAiCE;EACE,WAAA;EACA,yCAAA;EACA,eAAA;AA/BJ;AAkCE;EACE,cAAA;EACA,kBAAA;EACA,qCAAA;AAhCJ;AAmCE;EACE,+CAAA;EACA,0DAAA;AAjCJ;AAoCE;EACE,cAAA;EACA,eAAA;EACA,sCAAA;EACA,iBAAA;AAlCJ","sourcesContent":["wm-profile-edit {\n  .wm-profile-edit-form {\n    display: block;\n    padding: 16px;\n  }\n\n  .wm-profile-edit-avatar-container {\n    display: flex;\n    justify-content: center;\n    padding: 24px 16px 20px;\n  }\n\n  // Il bottone dell'avatar è ora l'intero elemento cliccabile (non più un link\n  // testuale separato \"Cambia foto\" sotto la foto) — il badge fotocamera\n  // sovrapposto (pattern riconoscibile: WhatsApp/Instagram/LinkedIn) comunica\n  // già da solo l'azione; l'aria-label copre l'accessibilità.\n  .wm-profile-edit-avatar {\n    position: relative;\n    width: 104px;\n    height: 104px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    border-radius: 50%;\n    cursor: pointer;\n\n    &:focus-visible {\n      outline: 2px solid var(--wm-color-primary, #4285f4);\n      outline-offset: 3px;\n    }\n  }\n\n  .wm-profile-edit-avatar-circle {\n    width: 100%;\n    height: 100%;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .wm-profile-edit-avatar-initials {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--wm-color-primary, #4285f4);\n    color: #fff;\n    font-size: 2.1rem;\n    font-weight: 600;\n    border-radius: 50%;\n  }\n\n  // Overlay di caricamento: scurisce la foto invece di nasconderla, cerchio\n  // pieno (non un rettangolo che sborda dall'avatar), spinner chiaro centrato.\n  .wm-profile-edit-avatar-scrim {\n    position: absolute;\n    inset: 0;\n    border-radius: 50%;\n    background: rgba(15, 17, 23, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .wm-profile-edit-avatar-spinner {\n    width: 30px;\n    height: 30px;\n  }\n\n  // Badge fotocamera sovrapposto al bordo dell'avatar — nascosto durante il\n  // caricamento (lo scrim+spinner sopra bastano, evita due indicatori insieme).\n  .wm-profile-edit-avatar-badge {\n    position: absolute;\n    bottom: -1px;\n    right: -1px;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: var(--wm-color-primary, #4285f4);\n    border: 3px solid var(--wm-color-white, #fff);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-size: 14px;\n  }\n\n  // Touch target minimo 44x44 (linee guida iOS/Android) sugli elementi\n  // interattivi del modale — l'avatar (104px) lo supera già ampiamente.\n  .wm-profile-edit-save-button {\n    min-height: 44px;\n    min-width: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    border: none;\n    background: var(--wm-color-primary, #4285f4);\n    color: #fff;\n    border-radius: 8px;\n    font-size: var(--wm-font-md, 1rem);\n    width: 100%;\n    margin-top: 16px;\n\n    &[disabled] {\n      opacity: 0.6;\n    }\n  }\n\n  // Opzione B (design review oc:8163): i campi vivono dentro un'unica ion-card\n  // contenuta invece che fluttuare direttamente sullo sfondo del modale — resta\n  // un modulo a scopo unico, non un menu; nuovi campi si aggiungono come nuovi\n  // .wm-profile-edit-field-container dentro la stessa card. `--wm-color-light`\n  // è bianco puro in questo tema (invisibile su sfondo bianco): si usa invece\n  // `--wm-color-greybackground`, il token dedicato a sfondi \"incassati\".\n  ion-card.wm-profile-edit-fields-card {\n    margin: 0 0 16px;\n    box-shadow: none;\n    background: var(--wm-color-greybackground, #f2f2f2);\n    border: 1px solid var(--wm-color-grey, #d2d2d2);\n    border-radius: 14px;\n    padding: 4px 14px;\n  }\n\n  .wm-profile-edit-field-container {\n    padding: 10px 0;\n\n    ion-item {\n      --background: transparent;\n      --padding-start: 0;\n      --inner-padding-end: 0;\n    }\n  }\n\n  .wm-profile-edit-field-divider {\n    height: 1px;\n    background: var(--wm-color-grey, #d2d2d2);\n    margin: 0 -14px;\n  }\n\n  .wm-profile-edit-label {\n    display: block;\n    margin-bottom: 4px;\n    font-size: var(--wm-font-sm, 0.85rem);\n  }\n\n  .wm-profile-edit-field-has-error {\n    --border-color: var(--wm-color-danger, #eb445a);\n    --highlight-color-focused: var(--wm-color-danger, #eb445a);\n  }\n\n  .wm-profile-edit-field-error {\n    display: block;\n    margin-top: 4px;\n    color: var(--wm-color-danger, #eb445a);\n    font-size: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
